interface BookDemoFormType {
    company_name: string;
    phone_number: string;
    email_id: string;
    linkedin_url: string;
    source: string;
    recaptchaToken: string;
    affiliateId?: string;
}

export const insertDemoDataInDB = async (formData: BookDemoFormType): Promise<void> => {
    const postOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${process.env.NEXT_PUBLIC_ANON_KEY}` },
        body: JSON.stringify(formData),
    };
    try {
        const response = await fetch(`${process.env.NEXT_PUBLIC_SUPABASE_URL}/functions/v1/addDemoBooking`, postOptions);
        const data = await response.json();
        return data;
    } catch (err) {
        console.error(err);
    }
};
